module.exports = __webpack_public_path__ + "static/media/shaws-department-stores.b11cc924.png";